<template>
  <div
    class="max-w-7xl mx-auto py-6 md:grid md:grid-cols-12 md:gap-x-5 md:px-4"
  >
    <aside class="py-6 px-2 sm:px-6 md:py-0 md:px-0 md:col-span-3">
      <nav class="space-y-1">
        <Link
          v-for="item in navigation"
          :key="item.name"
          :href="item.href"
          :class="[
            item.current
              ? 'bg-gray-50 text-blue-700 hover:text-blue-700 hover:bg-white'
              : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50',
            'group rounded-md px-3 py-2 flex items-center text-sm font-medium',
          ]"
          :aria-current="item.current ? 'page' : undefined"
        >
          <component
            :is="item.icon"
            :class="[
              item.current
                ? 'text-blue-500 group-hover:text-blue-500'
                : 'text-gray-400 group-hover:text-gray-500',
              'flex-shrink-0 -ml-1 mr-3 h-6 w-6',
            ]"
            aria-hidden="true"
          />
          <span class="truncate">
            {{ item.name }}
          </span>
        </Link>
      </nav>
    </aside>

    <div class="space-y-6 sm:px-6 md:px-0 md:col-span-9">
      <form action="#" method="POST">
        <div class="shadow sm:rounded-md sm:overflow-hidden">
          <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Change Password
              </h3>
              <p class="mt-1 text-sm text-gray-500">
                You can change your password here.
              </p>
            </div>

            <div class="grid grid-cols-7 gap-6">
              <div class="col-span-4">
                <label for="old" class="block text-sm font-medium text-gray-700"
                  >Old Password</label
                >
                <input
                  v-model="form.old"
                  type="password"
                  name="old"
                  id="old"
                  autocomplete="given-name"
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>

              <div class="col-span-4">
                <label
                  for="password"
                  class="block text-sm font-medium text-gray-700"
                  >New Password</label
                >
                <input
                  v-model="form.password"
                  type="password"
                  name="password"
                  id="password"
                  autocomplete="family-name"
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>

              <div class="col-span-4">
                <label
                  for="password_confirmation"
                  class="block text-sm font-medium text-gray-700"
                  >New Password Confirmation</label
                >
                <input
                  v-model="form.password_confirmation"
                  type="password"
                  name="password_confirmation"
                  id="password_confirmation"
                  autocomplete="family-name"
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>
          </div>
          <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
            <button
              type="submit"
              class="bg-blue-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Change Password
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { useForm, Link } from "@inertiajs/inertia-vue3";
import {
  Switch,
  SwitchDescription,
  SwitchGroup,
  SwitchLabel,
} from "@headlessui/vue";
import {
  CreditCardIcon,
  KeyIcon,
  UserCircleIcon,
  UserGroupIcon,
  ViewGridAddIcon,
} from "@heroicons/vue/outline";

const navigation = [
  {
    name: "Profile",
    href: window.route("profile.settings"),
    icon: UserCircleIcon,
    current: false,
  },
  {
    name: "Password",
    href: window.route("profile.password"),
    icon: KeyIcon,
    current: true,
  },
];

export default {
  props: {
    auth: Object,
  },

  setup(props) {
    const { auth } = props;

    const form = useForm({
      old: "",
      password: "",
      password_confirmation: "",
    });

    return {
      form,
      navigation,
    };
  },

  components: {
    Switch,
    SwitchDescription,
    SwitchGroup,
    SwitchLabel,
    Link,
  },
};
</script>
